// @flow

import type {SearchFilters} from '../../../containers/disputes/types';
import type {Filter} from '../types';

import moment from 'moment';

export const make = (values: SearchFilters): Filter => ({
  inDateBegin: values.period.from,
  inDateFinish: values.period.to,
  project: values.projects,
  instance: values.instances,
  reason: values.reasons,
  status: values.results,
  userId: values.userId,
  partnerEvidenceRequestStatus: values.partnerEvidenceRequestStatus
});

export const makeToAPI = (filter: Filter): Filter => ({
  inDateBegin:
    filter.inDateBegin &&
    moment(filter.inDateBegin)
      .utc()
      .startOf('day')
      .toDate(),
  inDateFinish:
    filter.inDateFinish &&
    moment(filter.inDateFinish)
      .utc()
      .endOf('day')
      .toDate(),
  userId: filter.userId ? [String(filter.userId)] : undefined,
  instance:
    filter.instance && filter.instance.length > 0 ? filter.instance.map(i => Number(i)) : undefined,
  project:
    filter.project && filter.project.length > 0 ? filter.project.map(p => Number(p)) : undefined,
  reason: filter.reason && filter.reason.length > 0 ? filter.reason.map(r => Number(r)) : undefined,
  status: filter.status && filter.status.length > 0 ? filter.status.map(s => Number(s)) : undefined,
  partnerEvidenceRequestStatus: filter.partnerEvidenceRequestStatus
    ? [String(filter.partnerEvidenceRequestStatus)]
    : undefined
});
